<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/projectList' }">網頁監控</el-breadcrumb-item>
                <el-breadcrumb-item>編輯專案</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="form-box">
                <div class="form-title">編輯專案</div>
                <FormTemplate :formParams="form"
                              :deafulcomForm="deafuleditForm"
                              @reset-form="resetForm"
                              :btnText="'重填'"
                              @on-submit="onSubmit" />
            </div>
        </div>
    </div>
</template>

<script>
import FormTemplate from '../../../components/FormTemplate.vue'
import { updateProjectList, updateProject } from '../../../api/index'
export default {
    components: {
        FormTemplate,
    },
    data() {
        return {
            projectId: '',
            form: {
                labelWidth: '150px',
                formList: [
                    {
                        label: '專案名稱',
                        key: 'name',
                        type: 'INPUT',
                        placeholder: '請輸入專案名稱',
                        require: true,
                        span: 24,
                    },
                    {
                        label: '專案排序',
                        key: 'sort',
                        type: 'INPUT',
                        placeholder: '請輸入專案排序',
                        require: true,
                        span: 24,
                    },
                ],
            },
            deafuleditForm: {},
        }
    },
    mounted() {
        if (typeof this.$route.query.projectId == 'undefined') {
            this.$router.push({ path: 'projectList' })
        } else {
            this.projectId = this.$route.query.projectId
            this.getData()
        }
    },
    methods: {
        getData() {
            updateProjectList({ id: this.projectId })
                .then((res) => {
                    if (res.code == 300) {
                        this.deafuleditForm = res.data.data_info
                    }
                })
                .catch(() => {
                    this.$message.error('失敗')
                })
        },
        onSubmit(form) {
            updateProject(form)
                .then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.$router.push({ path: 'projectList' })
                    } else if (res.code == 500) {
                        this.$message.error(res.message)
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$message.error('失敗')
                })
        },
        resetForm() {
            this.deafuleditForm = {}
        },
    },
}
</script>

<style lang="scss" scoped>
</style>